module.exports = __webpack_public_path__ + "img/11n.41d6d66f.png";